<template>
  <div>
    <LanguageSelector />
    <Alert :text="$t('profile edit message')" type="success" v-if="success" dismissable="true" />
    <Alert :text="$t('something went wrong')" type="danger" v-if="error" dismissable="true" />
    <Alert :text="$t('link reset validation')" type="success" v-if="changePasswordMessage == true" dismissable="true" />
    <Alert :text="$t('error in recovery email')" type="danger" v-if="changePasswordMessage == 'email error'" dismissable="true" />
    <div class="content-body" style="padding-bottom: 150px;">
        <!-- users edit start -->
        <section class="users-edit">
            <div class="card">
                <div class="card-content">
                    <div class="card-body">
                        <ul class="nav nav-tabs mb-2" role="tablist">
                            <li class="mb-1">
                                <button class="btn btn-primary" @click="changePassword()">
                                    {{$t('Change Password')}}
                                </button>
                            </li>
                        </ul>
                        <div class="tab-content">
                            <div class="tab-pane active fade show" id="account" aria-labelledby="account-tab" role="tabpanel">
                                <!-- users edit account form start -->
                                <form novalidate>
                                    <div class="row">
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <div class="controls">
                                                    <label>{{$t('Name')}}</label>
                                                    <input type="text" class="form-control" :placeholder="$t('Your Name')" v-model="name">
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="controls">
                                                    <label>{{$t('Email')}}</label>
                                                    <input type="text" class="form-control" :placeholder="$t('Your Email')" v-model="email" disabled>
                                                </div>
                                            </div>
                                            <div class="form-group">
                                                <div class="controls">
                                                    <label>{{$t('Language')}}</label>
                                                    <input type="text" class="form-control" :placeholder="$t('Your Language')" v-model="language" disabled>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="col-12 col-sm-6">
                                            <div class="form-group">
                                                <label>{{$t('Role')}}</label>
                                                <select class="form-control" disabled>
                                                    <option selected>{{ type.charAt(0).toUpperCase() + type.slice(1) }}</option>
                                                </select>
                                            </div>
                                            <div class="form-group">
                                                <label>{{$t('Position in Organisation')}}</label>
                                                <input type="text" class="form-control" :placeholder="$t('User Position in Organisation')" v-model="position">
                                            </div>
                                            <div class="form-group" v-if="this.$store.state.currentUser.user.phoneNumber">
                                                <label>{{$t('Phone Number')}}</label>
                                                <input type="text" class="form-control" :placeholder="$t('Phone Number')" v-model="phoneNumber" disabled>
                                            </div>
                                            <div class="form-group" v-else>
                                                <label>{{$t('Phone Number')}}</label>
                                                <input type="tel" id="phoneNumber" class="form-control" v-model="phoneNumberTarget">
                                            </div>
                                        </div>
                                        <div class="col-12 d-flex flex-sm-row flex-column justify-content-end mt-1">
                                            <button type="button" class="btn btn-primary glow mb-1 mb-sm-0 mr-0 mr-sm-1" @click="updateAdminData()">{{$t('Save Changes')}}</button>
                                        </div>
                                    </div>
                                </form>
                                <!-- users edit account form ends -->
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
        <!-- users edit ends -->
    </div>



    <div class="modal fade text-left" id="phone-verification-modal" tabindex="-1" role="dialog" aria-labelledby="create-modal-title" aria-hidden="true">
    <div class="modal-dialog modal-dialog-scrollable modal-sm" role="document">
        <div class="modal-content">
        <div class="modal-header">
            <h3 class="modal-title">{{$t('Verify Your Number')}}</h3>
            <button type="button" class="close rounded-pill" data-dismiss="modal" aria-label="Close">
            <em class="bx bx-x"></em>
            </button>
        </div>
        <div class="modal-body">
            <div class="form-group">
                <input maxlength="4" type="number" class="form-control" placeholder="0000" v-model="code">
            </div>
            <div class="text-center">
                <button type="button" class="btn btn-primary" @click="phoneVerification()">
                    <em class="bx bx-check d-block d-sm-none"></em>
                    <span class="d-none d-sm-block">{{$t('Verify Now')}}</span>
                </button>
            </div>
        </div>
        </div>
    </div>
    </div>
  </div>
</template>

<script>
  import { getLanguageName } from '@/app-assets/js/get-language.js'
  import Alert from '@/components/Alerts'
  import Swal from 'sweetalert';
  import "@/app-assets/js/scripts/extensions/ext-component-block-ui.js";

  export default {
    data() {
        return {
            name: this.$store.state.currentUser.user.name,
            email: this.$store.state.currentUser.user.email,
            position: this.$store.state.currentUser.user.position,
            type: this.$store.state.currentUser.user.type,
            phoneNumber: this.$store.state.currentUser.user.phoneNumber,
            languageCode: this.$store.state.currentUser.user.language,
            success: false,
            error: false,
            changePasswordMessage: false,
            code: '',
            phoneNumberObj: null,
            phoneNumberTarget: ''
        }
    },

    components: {
        Alert
    },

    methods: {
        changePassword(){
            let self = this
            this.changePasswordError = false;
            $.blockUI({
                message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                overlayCSS: {
                backgroundColor: "#fff",
                opacity: 0.8,
                cursor: "wait"
                },
                css: {
                border: 0,
                padding: 0,
                backgroundColor: "transparent"
                }
            });
            this.$apiCall.post('/v1/auth/send/recover', {
                email: this.email,
                language: (this.languageCode == 'en' || this.languageCode == 'ar') ? this.languageCode : 'en'
            })
            .then(response => {
                $.unblockUI();
                this.handleSweetAlertPopup();
            })
            .catch(err => {
                $.unblockUI()
                if(err.response.status == 405){
                    this.changePasswordMessage = 'email error'
                }
            })
        },

        handleSweetAlertPopup() {
            Swal({
                type: 'success',
                title: "$t('swall-link reset validation')",
                showConfirmButton: false,
                timer: 2500,
                buttonsStyling: false,
            })
            .then(() => this.logout());
        },

        phoneVerificationMessage(){
            let self = this
            if(!this.$store.state.currentUser.user.phoneNumber && this.phoneNumberTarget){
                let countryData = this.phoneNumberObj.getSelectedCountryData()
                let pN = '%2B' + countryData.dialCode + this.phoneNumberTarget.replace(`+${countryData.dialCode}`, "")
                $("#phone-verification-modal").modal()
                self.$apiCall.put(`/v1/me/verify/phone?phoneNumber=${pN}`)
                .then(response => {
                    $("#phone-verification-modal").modal()
                })
            }
        },

        phoneVerification(){
            let self = this
            let countryData = this.phoneNumberObj.getSelectedCountryData()
            let pN = '+' + countryData.dialCode + this.phoneNumberTarget.replace(`+${countryData.dialCode}`, "")

            var block_ele = $("#phone-verification-modal .modal-content");
            $(block_ele).block({
            message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
            overlayCSS: {
                backgroundColor: "#fff",
                opacity: 0.8,
                cursor: "wait"
            },
            css: {
                border: 0,
                padding: 0,
                backgroundColor: "transparent"
            }
            });

            this.$apiCall.post('/v1/me/verify/phone', {
                "phoneNumber": pN,
                "verificationCode": parseInt(self.code)
            })
            .then(response => {
                $(block_ele).unblock();
                self.$store.dispatch('currentUser/editProfile', response.data)
                $("#phone-verification-modal").modal('hide')
            })
        },

        updateAdminData(){
            let self = this
            $.blockUI({
                message: '<div class="bx bx-revision icon-spin font-medium-2"></div>',
                overlayCSS: {
                backgroundColor: "#fff",
                opacity: 0.8,
                cursor: "wait"
                },
                css: {
                border: 0,
                padding: 0,
                backgroundColor: "transparent"
                }
            });
            this.$apiCall.patch('/v1/me', {
                "name": self.name,
                "position": self.position,
            })
            .then(response => {
                $.unblockUI();
                self.$store.dispatch('currentUser/editProfile', response.data)
                self.success = true
                self.phoneVerificationMessage()
            })
            .catch(error => {
                $.unblockUI();
                self.error = true
            })
        },

        initTelInput(){
            let input = document.querySelector("#phoneNumber")
            this.phoneNumberObj = intlTelInput(input)
        },

        logout(){
            location.href = '/logout'
        },
    },

    watch: {
        phoneNumberTarget: function(value) {
            this.phoneNumberTarget = value.replace(/[^\d|\-+]/g,'')
        }
    },

    computed: {
        language(){
            return getLanguageName(this.$store.state.currentUser.user.language)
        },

        docusignAuth(){
            return localStorage.getItem('dTok')
        }
    },

    mounted() {
        if(!this.$store.state.currentUser.user.phoneNumber){
            this.initTelInput()
        }
    }
  }
</script>


